import { apiCall } from "./servicesCall";

export const OTHER_SERVICES = {
  contact(data) {
    return apiCall("/6ix/contact", data);
  },
  interestHostEvent(data) {
    return apiCall("/6ix/host-event", data);
  },
  feedback(data) {
    return apiCall("/6ix/feedback", data);
  },
  demoRequest(data) {
    return apiCall("/6ix/demo", data);
  },
  demoRequestMeeting(data) {
    return apiCall("/6ix/demo/meeting", data);
  },
  companyReportIssue(data) {
    return apiCall("/6ix/company-report-issue", data);
  },
  companyClaim(data) {
    return apiCall("/6ix/company-claim", data);
  },
};
